import React from 'react';
import Button from 'react-bootstrap/Button';
import { TitleFormattedMessage } from '../../../titleFormattedMessage';

/**
 * Props for the DocumentWizardHeaderUnshareButton component
 */
export interface DocumentWizardHeaderUnshareButtonProps {
  /** Handler called when user clicks the unshare button */
  onClick: () => void;
}

/**
 * Unshare button component for removing counterparty access to executed documents.
 * Displayed in the document header when the document is executed and has a receiver team.
 *
 * @param {DocumentWizardHeaderUnshareButtonProps} props - Component props
 * @returns {JSX.Element} Unshare button
 */
const DocumentWizardHeaderUnshareButton = ({
  onClick,
}: DocumentWizardHeaderUnshareButtonProps) => (
  <Button onClick={onClick} className="document-wizard-header__unshare-button">
    <TitleFormattedMessage
      id="document-wizard-header.action.unshare"
      defaultMessage="Unshare"
      data-testid="document-wizard-header-unshare-action"
    />
  </Button>
);

export default DocumentWizardHeaderUnshareButton;
